import { createContext, useContext } from 'react';

/** La part de `useFilterState` qu'une vue imbriquée peut avoir besoin de lire. */
export type DataViewFilterState = {
    filterState: Record<string, unknown>;
    searchValue: string;
    searchKey: string;
    updateFilter: (key: string, value: unknown) => void;
    updateSearch: (value: string) => void;
    clearFilters: () => void;
};

export type DataViewContextValue = {
    filters: DataViewFilterState;
};

/**
 * Signale à une `DataTable` qu'une `DataView` l'englobe. Deux conséquences, et c'est tout :
 *
 * 1. elle ne rend pas sa propre barre d'outils — la `DataView` porte la recherche et les chips, une
 *    seule fois pour toutes ses vues ;
 * 2. elle ne synchronise pas l'URL — sinon deux écrivains se disputeraient les mêmes paramètres.
 *
 * La sélection ne passe PAS par ici : la `DataView` la donne à chaque vue en props, comme aujourd'hui.
 */
export const DataViewContext = createContext<DataViewContextValue | null>(null);

export function useDataViewContext(): DataViewContextValue | null {
    return useContext(DataViewContext);
}
